import React from 'react'
import logo from "./images/yemi1.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars } from "@fortawesome/free-solid-svg-icons";


function NavBar() {
    return (
        <div><a name="navbar"></a>
            <nav className="navbar navbar-expand-lg navbar-light bg-dark">
                <div className="container">
                    <a className="navbar-brand" href=""><img className="logo" src={logo} alt="Yemi"></img></a>
                    <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                        <FontAwesomeIcon icon={faBars} style={{ color: "#fff" }} />
                    </button>

                    <div className="collapse navbar-collapse mynav" id="navbarSupportedContent">
                        <ul className="navbar-nav ml-auto">
                        {/* <li className="nav-item active">
                            <a className="nav-link" href="index.html">Home <span className="sr-only">(current)</span></a>
                        </li> */}
                        <li className="nav-item">
                            <a className="nav-link" href="#about">about</a>
                        </li>
                        <li className="nav-item">
                            <a className="nav-link" href="#experience">experience</a>
                        </li>                      
                        <li className="nav-item">
                            <a className="nav-link" href="#portfolio">portfolio</a>
                        </li>
                        <li className="nav-item">
                            <a className="nav-link" href="#services">services</a>
                        </li>                          
                        <li className="nav-item">
                            <a className="nav-link" href="#certificate">Certificates</a>
                        </li>                        
                        <li className="nav-item">
                            <a className="nav-link btn btn-outline-success" href="#contact">contact Me</a>
                        </li>                        
                        </ul>
                    
                    </div>
                </div>                
            </nav>
        </div>
    )
}

export default NavBar
